export default "__VITE_ASSET__Dv$6dcSP__"